
export enum Status {
    NoActivo = 0,
    Activo = 1,
    Baja = 2,
    Pendiente = 3,
    EnProceso = 4,
    Enviado = 5,
    Error = 6,
    PendienteDeAprobar = 7,
    Aprobado = 8,
    BajaCRM = 9,
    Pausado = 10,
    GastoPendienteAprobacion = 11,
    GastoAprobado = 12,
    GastoRechazado = 13,
    FacturaPendienteAprobacion = 14,
    FacturaAprobada = 15,
    FacturaRechazada = 16,
    Presente = 17,
    ContactoComEscultor = 18,
    EnvioDeKitDeEventos = 19,
    Concluido = 20
}